import { useTranslation } from 'react-i18next';

interface BookingStepperProps {
  currentStep: number;
}

const TOTAL_STEPS = 4;

/**
 * Compact progress header for the booking accordion.
 * The accordion itself shows the step labels and completed summaries,
 * so this only indicates overall progress ("Paso X de 4" + pills).
 */
export function BookingStepper({ currentStep }: BookingStepperProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full max-w-3xl mx-auto mb-6">
      <p className="text-xs font-medium text-ink-subtle uppercase tracking-wide text-center mb-3">
        {t('booking.accordion.stepOf', { current: currentStep, total: TOTAL_STEPS })}
      </p>

      {/* Simple Progress Indicator - Horizontal Pills */}
      <div className="flex justify-center gap-2">
        {Array.from({ length: TOTAL_STEPS }, (_, i) => i + 1).map((step) => (
          <div
            key={step}
            className={`
              h-1.5 rounded-full transition-all duration-300
              ${step === currentStep ? 'w-8' : 'w-2'}
              ${currentStep >= step ? 'bg-accent' : 'bg-surface-3'}
            `}
          />
        ))}
      </div>
    </div>
  );
}
